import React, { useState } from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import '../../../cards/AuthPromo/index.js';
import { Card } from '../../../cards/Card/index.js';
import '../../../cards/CategoryCard/index.js';
import '../../../cards/CryptoFeature/index.js';
import { GamePreview } from '../../../cards/GamePreview/index.js';
import '../../../cards/Promo/PromoCardSimple/index.js';
import '../../../cards/Promo/PromotionCard/index.js';
import '../../../cards/Provider/index.js';
import '../../../cards/SportsBook/index.js';
import '../../../cards/SecurityCard/index.js';
import '../../../cards/WinCard/index.js';
import '../../../common/DateFormat/index.js';
import { ExpandContent } from '../../../common/ExpandContent/index.js';
import '../../../common/GradientWrapper/index.js';
import { Icon } from '../../../common/Icon/index.js';
import '../../../common/LazyImage/index.js';
import '../../../common/NumberFormat/index.js';
import '@anton.bobrov/react-components';
import '../../../common/WithCustomScrollbar/index.js';
import { useWindowSize } from '../../../../utils/hooks/useWindowSize.js';
import styles from './index.module.scss.js';

const GameAccordion = ({
  title,
  description,
  tags = [],
  edge,
  gameData,
  animation = {
    "data-aos": "fade-up-sm",
    "data-aos-delay": "100",
    "data-aos-duration": "1000"
  },
  text = {
    edge: "Edge:"
  },
  ...props
}) => {
  const [isActive, setIsActive] = useState(true);
  const { isDesktop, windowSize } = useWindowSize();
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ...props,
      ...animation,
      className: cx(styles.box, {
        [styles.open]: isActive
      })
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles.button),
        tabIndex: 0,
        role: "button",
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            setIsActive(!isActive);
          }
        },
        onClick: () => setIsActive(!isActive)
      },
      isDesktop && isActive && gameData && /* @__PURE__ */ React.createElement("div", { className: styles["big-preview"] }, /* @__PURE__ */ React.createElement(Card, { type: "GAME_V2", ...gameData })),
      gameData && (!isActive || !isDesktop) && /* @__PURE__ */ React.createElement("div", { className: styles["small-preview"] }, /* @__PURE__ */ React.createElement(
        GamePreview,
        {
          href: gameData.href || "/",
          title: gameData.title,
          subtitle: gameData.subtitle,
          image: gameData.thumbnailImage || gameData.imageLayers?.mediaImage
        }
      )),
      /* @__PURE__ */ React.createElement("div", { className: styles.button__text }, /* @__PURE__ */ React.createElement("span", null, title), windowSize.width < 1024 && !isActive && /* @__PURE__ */ React.createElement("div", { className: styles.tags }, tags.map((item) => /* @__PURE__ */ React.createElement(
        Link,
        {
          to: item.href,
          key: item.id,
          className: styles.tag,
          onClick: item.onClick
        },
        item.name
      )))),
      !isActive && isDesktop && /* @__PURE__ */ React.createElement("div", { className: styles.tags }, tags.map((item) => /* @__PURE__ */ React.createElement(
        Link,
        {
          to: item.href,
          key: item.id,
          className: styles.tag,
          onClick: item.onClick
        },
        item.name
      ))),
      /* @__PURE__ */ React.createElement("div", { className: styles["arrow-down"] }, /* @__PURE__ */ React.createElement(Icon, { iconName: "ArrowDownV2" }))
    ),
    /* @__PURE__ */ React.createElement(
      ExpandContent,
      {
        isActive,
        style: {
          width: "100%"
        }
      },
      /* @__PURE__ */ React.createElement("div", { className: styles.panel }, /* @__PURE__ */ React.createElement("div", { className: styles["card-col"] }), /* @__PURE__ */ React.createElement("div", { className: styles["content-col"] }, /* @__PURE__ */ React.createElement("div", { className: styles.text }, description), /* @__PURE__ */ React.createElement("div", { className: styles.panel__footer }, /* @__PURE__ */ React.createElement("div", { className: styles.edge }, text.edge, " ", edge, "%"), /* @__PURE__ */ React.createElement("div", { className: styles.tags }, tags.map((item) => /* @__PURE__ */ React.createElement(
        Link,
        {
          className: styles.tag,
          to: item.href,
          key: item.id,
          onClick: item.onClick
        },
        item.name
      ))))))
    )
  );
};
GameAccordion.displayName = "GameAccordion";

export { GameAccordion };
//# sourceMappingURL=index.js.map
